import {
  BrowserRouter as Router,
  Route,
  Routes
} from "react-router-dom";
import AppLayout from "./components/AppLayout";
import SignupPage from "./components/SignupPage";
import ChatHub from "./components/ChatHub";
import DiscoverPage from "./components/DiscoverPage";
import MyGroup from "./components/MyGroup";
import OrdersPage from "./components/OrdersPage";
import StrategiesPage from "./components/StrategiesPage";
import TradingPage from "./components/TradingPage";
import LotteryPage from "./components/LotteryPage";
import RealLotteryPage from "./components/RealLotteryPage";
import LotteryPlay from "./components/LotteryPlay";
import LotteryWinners from "./components/LotteryWinners";
import TokenTracking from "./components/TokenTracking";
import { ProfitableSwap } from "./components/ProfitableSwap";
import { SwapLottery } from "./components/SwapLottery";

export default function AppRouter() {
  return (
    <Router>
      <Routes>
        {/* Signup page - wallet connection required */}
        <Route path="/" element={<SignupPage />} />
        
        {/* Authenticated routes with layout */}
        <Route path="/chat" element={
          <AppLayout>
            <ChatHub />
          </AppLayout>
        } />
        <Route path="/discover" element={
          <AppLayout>
            <DiscoverPage />
          </AppLayout>
        } />
        <Route path="/mygroup" element={
          <AppLayout>
            <MyGroup />
          </AppLayout>
        } />
        <Route path="/orders" element={
          <AppLayout>
            <OrdersPage />
          </AppLayout>
        } />
        <Route path="/strategies" element={
          <AppLayout>
            <StrategiesPage />
          </AppLayout>
        } />
        <Route path="/orders/trading" element={
          <AppLayout>
            <TradingPage />
          </AppLayout>
        } />
        <Route path="/lottery" element={
          <AppLayout>
            <RealLotteryPage />
          </AppLayout>
        } />
        <Route path="/lottery/play" element={
          <AppLayout>
            <LotteryPlay />
          </AppLayout>
        } />
        <Route path="/lottery/winners" element={
          <AppLayout>
            <LotteryWinners />
          </AppLayout>
        } />
        <Route path="/tracking" element={
          <AppLayout>
            <TokenTracking />
          </AppLayout>
        } />
        <Route path="/profitable-swap" element={
          <AppLayout>
            <ProfitableSwap />
          </AppLayout>
        } />
        <Route path="/swap-lottery" element={
          <AppLayout>
            <SwapLottery />
          </AppLayout>
        } />
      </Routes>
    </Router>
  )
}